export default __webpack_public_path__ + "static/media/icon-doctor-avatar.1ee2e899.svg";